import React from 'react'

interface AiRobotIconProps {
  className?: string
  color?: string
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const AiRobotIcon: React.FC<AiRobotIconProps> = ({ 
  className = '', 
  color = '#f357bb' 
}) => {
  return (
    <svg 
      width="200" 
      height="200" 
      viewBox="0 0 200 200" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M100 33.3332V58.3327M100 33.3332C104.602 33.3332 108.333 29.6022 108.333 24.9998C108.333 20.3975 104.602 16.6665 100 16.6665C95.3976 16.6665 91.6667 20.3975 91.6667 24.9998C91.6667 29.6022 95.3976 33.3332 100 33.3332ZM79.1667 154.166H120.833M12.5 104.167V137.5M187.5 104.167V137.5M29.1667 158.333V83.3327C29.1667 69.5256 40.3595 58.3327 54.1667 58.3327H145.833C159.64 58.3327 170.833 69.5256 170.833 83.3327V158.333C170.833 172.14 159.64 183.333 145.833 183.333H54.1667C40.3595 183.333 29.1667 172.14 29.1667 158.333ZM75 108.333C75 112.936 71.269 116.667 66.6667 116.667C62.0643 116.667 58.3333 112.936 58.3333 108.333C58.3333 103.731 62.0643 99.9998 66.6667 99.9998C71.269 99.9998 75 103.731 75 108.333ZM141.667 108.333C141.667 112.936 137.936 116.667 133.333 116.667C128.731 116.667 125 112.936 125 108.333C125 103.731 128.731 99.9998 133.333 99.9998C137.936 99.9998 141.667 103.731 141.667 108.333Z" 
        stroke={color} 
        strokeLinecap="round" 
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  )
}